import { format, parseISO } from 'date-fns';
import locale from 'date-fns/locale/pt-BR';
import { useMemo } from 'react';
import { useDeleteTaxa } from './useDeleteTaxa';
import { useToggleStatusTaxa } from './useToggleStatusTaxa';
import { ITaxa } from './useQueryFilterTaxas/index.d';

export const useTransformTaxas = (props, { administrador }) => {
    const taxas: ITaxa[] = props.response || [];
    const { handleDeleteTaxa } = useDeleteTaxa(props);
    const { handleToggleStatusTaxa } = useToggleStatusTaxa(props);

    const data = useMemo(() => {
        return taxas.map((taxa) => {
            const dataInicio = format(
                parseISO(taxa?.dataInicio || new Date().toISOString()),
                `dd 'de' MMMM 'de' yyyy 'às' HH:mm`,
                { locale }
            );

            const dataFim = format(
                parseISO(taxa?.dataFim || new Date().toISOString()),
                `dd 'de' MMMM 'de' yyyy 'às' HH:mm`,
                { locale }
            );

            const valorAdicionalJogoRapido = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(taxa?.valorAdicionalJogoRapido || 0);

            const valorAdicionalEntregador = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(taxa?.valorAdicionalEntregador || 0);

            const menuAcoes = [
                {
                    titulo: taxa?.status === 1 ? 'Desativar taxa' : 'Ativar taxa',
                    click: handleToggleStatusTaxa,
                    data: taxa,
                    color: taxa?.status === 0 ? 'red' : 'green',
                    icone: taxa?.status === 1 ? 'icon-like' : 'icon-deslike',
                },
            ];

            return {
                lineClassName: '',
                colunas: [
                    {
                        tipo: 'Texto',
                        width: '30rem',
                        marginRight: '0',
                        titulo: dataInicio,
                    },
                    {
                        tipo: 'Texto',
                        width: '30rem',
                        marginRight: '0',
                        titulo: dataFim,
                    },
                    {
                        tipo: 'Texto',
                        width: '20rem',
                        marginRight: '0',
                        titulo: valorAdicionalJogoRapido,
                    },
                    {
                        tipo: 'Texto',
                        width: '20rem',
                        marginRight: '0',
                        titulo: valorAdicionalEntregador,
                    },
                    {
                        tipo: 'Texto',
                        width: '30rem',
                        marginRight: '0',
                        titulo: taxa?.u_nomeCompleto || '',
                    },
                    {
                        tipo: 'Texto',
                        width: '20rem',
                        marginRight: '0',
                        titulo: '',
                        botoesInline: menuAcoes,
                    },
                ],
            };
        });
    }, [taxas, administrador, handleToggleStatusTaxa]);

    return data;
};